import request, { ApiResponse } from './request';

export interface DateRangeParams {
  start_date?: string;
  end_date?: string;
}

export function getSalesOverview(params?: DateRangeParams): Promise<ApiResponse<any>> {
  return request.get('/statistics/overview', { params });
}

export function getStatsByVillage(params?: DateRangeParams): Promise<ApiResponse<any[]>> {
  return request.get('/statistics/by-village', { params });
}

export function getStatsByCategory(params?: DateRangeParams): Promise<ApiResponse<any[]>> {
  return request.get('/statistics/by-category', { params });
}

export function getStatsByMonth(): Promise<ApiResponse<any[]>> {
  return request.get('/statistics/by-month');
}

export function getTopCustomers(params?: DateRangeParams & { limit?: number }): Promise<ApiResponse<any[]>> {
  return request.get('/statistics/top-customers', { params });
}
